const ko = {
    error1: '서버 오류입니다. 다시 시도해 주세요',
    error1_1: '내부 서버 오류입니다. 나중에 다시 시도하세요',
    error1_2: '서버가 요청을 지원하지 않습니다. 나중에 다시 시도하세요',
    error1_3: '서버를 사용할 수 없습니다. 나중에 다시 시도하세요',
    error1_4: '서버 게이트웨이 시간 초과, 나중에 다시 시도하세요',
    error1_5: '서버가 HTTP 버전을 지원하지 않습니다. 나중에 다시 시도하세요',
    error2: '요청 데이터를 전달해야 합니다',
    error3: '매개변수 오류',
    error4: '데이터베이스가 초기화되지 않았습니다',
    error5: '열거형 오류',
    error6: '매개변수 전송 오류',
    error7: '토큰이 없거나 만료되었습니다',
    error8: 'preUpload.Id가 존재하지 않습니다',
    error9: 'fileInfo.Id가 존재하지 않습니다',
    error10: '파일 인덱스가 이미 존재합니다',
    error11: '파일에 일부가 없습니다',
    error12: '해당 파일을 찾을 수 없습니다',
    error13: '관리자 권한은 수정할 수 없습니다',
    error14: '새로 고침 토큰이 존재하지 않습니다',
    error15: '해당 데이터를 찾을 수 없습니다',
    error16: '전화번호를 찾을 수 없습니다',
    error17: '이 전화번호는 이미 존재합니다',
    error18: '계정 또는 비밀번호 오류',
    error19: '여러 직원이 존재하지 않습니다',
    error20: '조직을 찾을 수 없습니다',
    error21: '해당 직원은 이미 조직에 존재합니다',
    error22: '조직이 재고를 조사하고 있습니다',
    error23: '일지가 존재하지 않습니다',
    error24: '문서가 존재하지 않습니다',
    error25: '제품 유형이 존재하지 않습니다',
    error26: '제품이 존재하지 않습니다',
    error27: '스캔이 존재하지 않습니다',
    error28: '여러 스캔이 존재하지 않습니다',
    error29: '이 스캔에는 이미 바코드가 존재합니다',
    error30: '아웃바운드/인바운드 주문 데이터를 찾을 수 없습니다',
    error31: '재고가 부족합니다',
    error32: '재고 목록을 찾을 수 없습니다',
    error33: '재고 항목이 존재하지 않습니다',
    error34: '코드가 이미 존재하므로 다시 추가할 수 없습니다! ',
    error35: '네트워크 오류입니다. 네트워크 연결을 확인하고 다시 시도하세요. ',
    error36: '요청 시간이 초과되었습니다. 다시 시도하세요. ',
    error37: '제품 카테고리 코드가 반복되었습니다. ',
    error38: '스캔된 양식에 제품 데이터와 바코드 데이터가 없어 창고에 들어가거나 나갈 수 없습니다. 페이지가 곧 닫힙니다. ',
    error39: '재고 부족',
    error40: '초과 출고 신청이 존재하지 않습니다',
    error41: '신청 상태가 이 작업을 허용하지 않습니다',
    error42: '요구 사항 세부 정보가 유효하지 않거나 일치하지 않습니다',
    error43: '초과 출고 수량은 0보다 커야 합니다',
    error44: '초과 출고 세부 정보가 이미 출고 주문을 생성했습니다',
    error45: '고객 코드가 이미 존재합니다',
    error46: '배송 주소를 찾을 수 없습니다',
    error47: '수취인 이름이 이미 존재합니다',
    error48: '장비를 찾을 수 없습니다',
    error49: '현재 장비 상태에서는 이 작업을 수행할 수 없습니다',
    error50: '장비가 재고 상태가 아니므로 대여할 수 없습니다',
    error51: '장비가 사용 중 상태가 아니므로 반납할 수 없습니다',
    error52: '장비에 아직 반납되지 않은 대여 기록이 있습니다',
    error53: '이 기록 유형은 전용 API를 사용해야 합니다',
    error54: '장비가 이미 폐기되었습니다',
    error55: '잘못된 장비 상태 전환입니다',
    error56: '유지보수 설정이 올바르지 않습니다',
    error57: '자산 번호가 이미 존재합니다',
    error58: '장비 기록을 찾을 수 없습니다',
    error59: '장비 카테고리 코드가 이미 존재합니다',
    error60: '장비 카테고리를 찾을 수 없습니다',
    error61: '상위 카테고리가 활성화되지 않아 하위 카테고리를 활성화할 수 없습니다',
    error62: '하위 카테고리가 있어 삭제할 수 없습니다',
    error63: '이미 사용 중인 카테고리이므로 코드나 이름을 변경할 수 없습니다',
    error64: '보관 부서는 필수입니다',
    error65: '장비는 최하위 카테고리에만 연결할 수 있습니다',
    error66: "작업이 대기열에서 실행 중입니다. 잠시 후 다시 시도하세요",
};

export default ko;
